<template>
    <div v-if="proposal" class="purchases_create atmo-page">
        <b-container fluid class="purchase-offer-header-block">
            <b-container>
                <b-row>
                    <b-col>
                        <p class="fs-40 fw-600 white-color mt-3 mb-3">Предложение на закупку 44ФЗ с неопределённым объёмом № {{ proposal.purchase.reg_number }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="white-color fs-14"><b>Статус</b>: {{ proposal.status.title }}</p>
                        <p class="white-color fs-14" v-if="proposal.status.id === 'rejected' && proposal.rejection_reason">
                            <b>Причина отклонения</b>: {{ proposal.rejection_reason }}<br />
                            <template v-if="proposal.rejection_comment"><b>Комментарий заказчика</b>: {{ proposal.rejection_comment }}<br /></template>
                            <template v-if="proposal.rejection_attachment?.id">
                                <b>Приложенный заказчиком документ</b>: <a :href="$getAttachmentDownloadLink(proposal.rejection_attachment.id)" class="white-system_link-style" target="_blank">{{ proposal.rejection_attachment.name }}</a>
                            </template>
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container fluid class="my-2">
            <b-container>
                <text-header v-if="!['draft', 'signed', 'revoked', 'blocked'].includes(proposal.purchase.status.id)">
                    Закупка 44ФЗ №
                    <router-link class="system_link-style" target="_blank" :to="{ name: 'Fl44UnknownVolumePurchaseShow', params: { id: proposal.purchase.id } }">{{ proposal.purchase.reg_number }} ({{ proposal.purchase.status.title }})</router-link>
                </text-header>
                <text-header v-else> Закупка 44ФЗ № {{ proposal.purchase.reg_number }} ({{ proposal.purchase.status.title }}) </text-header>
                <text-row-single-document compact label="Карточка предприятия" v-model="proposal.organization_card" />
                <text-row label="Контактное лицо поставщика" v-model="proposal.contact_name" compact />
                <text-row-boolean-text compact v-model="proposal.without_vat" label="Без НДС" />
                <text-header>Подтверждение требований к поставщикам</text-header>
                <text-row-boolean-text
                    v-if="proposal.purchase.supplier_requirements.only_smp"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    value-class="text-right mr-2"
                    label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)"
                    v-model="proposal.purchase.supplier_requirements.only_smp"
                    compact />

                <template v-if="proposal.purchase.supplier_requirements.supplier_reqs_a">
                    <text-row-boolean-text
                        :label-cols-sm="11"
                        :label-cols-lg="11"
                        value-class="text-right mr-2"
                        v-model="proposal.supplier_requirements_confirmed.supplier_reqs_a"
                        label="Подтверждаю, что соответствую требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                        compact />
                    <div style="word-break: break-all" class="form-row">
                        <div class="col fs-14 grey-color my-1">
                            <p class="fs-14 grey-color my-1"><strong>Подтверждаю, что соответствую следующим требованиям</strong> - {{ proposal.purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text }}</p>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col">
                            <p class="fs-14 grey-color mt-2 mb-1"><strong>Подтверждаю, что соответствую указанным требованиям, приложив следующие документы:</strong></p>
                        </div>
                    </div>
                    <text-row-single-document
                        :compact="true"
                        :label-cols-lg="5"
                        :label-cols-sm="5"
                        v-for="(document, index) in proposal.supplier_requirements_confirmed.supplier_required_documents"
                        :label="`${index + 1}. ${document.name}`"
                        v-model="document.storedDocument"
                        :key="`supplier_required_document_${document.id}`" />
                </template>
                <text-row-boolean-text
                    v-if="proposal.purchase.supplier_requirements.supplier_reqs_b"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    value-class="text-right mr-2"
                    v-model="proposal.supplier_requirements_confirmed.supplier_reqs_b"
                    label="Подтверждаю, что соответствую требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    compact />
                <text-row-boolean-text
                    v-if="proposal.purchase.supplier_requirements.supplier_reqs_c"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    value-class="text-right mr-2"
                    v-model="proposal.supplier_requirements_confirmed.supplier_reqs_c"
                    label="Подтверждаю, что соответствую требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    compact />
                <text-row-boolean-text
                    v-if="proposal.purchase.supplier_requirements.supplier_reqs_sonko"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    value-class="text-right mr-2"
                    v-model="proposal.supplier_requirements_confirmed.supplier_reqs_sonko"
                    label="Подтверждаю, организация является социально ориентированной некоммерческой организацией (СОНКО)"
                    compact />
                <template v-if="proposal.purchase.supplier_requirements.has_additional_requirements">
                    <div class="form-row">
                        <div class="col">
                            <p class="fs-14 grey-color my-2 mb-1">
                                <strong>Подтверждаю соответствие дополнительным требованиям, приложив следующие документы:</strong>
                            </p>
                        </div>
                    </div>
                    <text-row-single-document
                        :compact="true"
                        :label-cols-lg="5"
                        :label-cols-sm="5"
                        v-for="(document, index) in proposal.supplier_requirements_confirmed.additional_requirements"
                        :label="`${index + 1}. ${document.description} (Причина: ${document.reason})`"
                        v-model="document.attachment"
                        :key="`attachment_${document.id}`" />
                </template>
                <text-row-single-document v-if="proposal.commercial_proposal" compact label="Коммерческое предложение" v-model="proposal.commercial_proposal" :label-cols-lg="5" :label-cols-sm="5" />
                <text-row-documents compact label="Дополнительные документы" v-model="proposal.attachments" v-if="proposal.attachments.length > 0" :label-cols-lg="5" :label-cols-sm="5" />

                <text-row-proposal-specification-table v-model="proposal.deliverables" :without-vat="proposal.without_vat" />
            </b-container>
        </b-container>
        <b-container fluid class="my-2" id="action_buttons_row">
            <b-container class="mb-5">
                <template v-if="$store.getters.isLoggedIn && proposal.actions.supplier.edit">
                    <b-button variant="custom-green" class="text-nowrap text-uppercase" :to="{ name: 'Fl44UnknownVolumePurchaseNewProposal', params: { id: proposal.purchase.id } }"> Изменить предложение </b-button>
                </template>
            </b-container>
        </b-container>
    </div>
</template>

<script>
import TextRowSingleDocument from '@/components/common/form-rows/text-row-single-document.vue';
import TextRowProposalSpecificationTable from '@/components/proposals/partials/text-row-proposal-specification-table.vue';

export default {
    metaInfo: {
        title: 'Предложение на закупку 44ФЗ с неопределённым объёмом'
    },
    name: 'fl44-unknown-volume-proposal-show',
    components: {
        TextRowProposalSpecificationTable,
        TextRowSingleDocument
    },
    data() {
        return {
            id: this.$route.params.id,
            proposal: null,
            visible: []
        };
    },
    async mounted() {
        await this.fillData();
    },
    methods: {
        async fillData() {
            this.proposal = await this.$api.personal.fl44UnknownVolume.getProposal(this.id);
            this.$scrollToHash();
        },
        refresh() {
            this.fillData();
        }
    }
};
</script>

<style scoped>
.purchase-offer-header-block {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}
.link {
    color: var(--green-color) !important;
}
.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}
.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}
</style>
